<kendo-dialog-titlebar>
    Save Conflict
</kendo-dialog-titlebar>
<div class="conflict-dialog-content">
    <span class="k-icon k-i-warning conflict-dialog-icon" aria-hidden="true"></span>
    <p class="conflict-dialog-message">{{message}}</p>
</div>
